import { render, staticRenderFns } from "./IncorrectLanes.vue?vue&type=template&id=6ed55d2c&"
import script from "./IncorrectLanes.vue?vue&type=script&lang=js&"
export * from "./IncorrectLanes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports